module.exports = __webpack_public_path__ + "static/media/category-bg.1f6b38fd.jpg";